import {imagePizza} from "../Pizza/imagePizza";

export const pizza = [
    {
        id: 71,
        img: imagePizza.florencia,
        title: 'ФЛОРЕНЦИЯ',
        structure: 'МОЦАРЕЛЛА, ПЕРЕЦ БОЛГАРСКИЙ,ГОВЯДИНА ПИКАНТНАЯ,БЕКОН,ТОМАТЫ,СОУС.',
        price: '460',
        weight: '600',
    },
    {
        id: 72,
        img: imagePizza.sicilia,
        title: 'СИЦИЛИЯ',
        structure: 'МОЦАРЕЛЛА, ПЕРЕЦ БОЛГАРСКИЙ,ПАРМЕЗАН,ФИЛЕ КУРИНОЕ,ТОМАТЫ,СОУС.',
        price: '485',
        weight: '600',
    },
    {
        id: 73,
        img: imagePizza.peperoni,
        title: 'ПЕППЕРОНИ',
        structure: 'МОЦАРЕЛЛА, ПЕППЕРОНИ,СОУС.',
        price: '440',
        weight: '600',
    },
    {
        id: 74,
        img: imagePizza.parma,
        title: 'ПАРМА',
        structure: 'МОЦАРЕЛЛА, ПЕРЕЦ БОЛГАРСКИЙ,ФИЛЕ КУРИНОЕ,БЕКОН,ТОМАТЫ,СОУС.',
        price: '460',
        weight: '600',
    },
]